export const unregisterOidcServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    return
  }

  const registrations = await navigator.serviceWorker.getRegistrations()
  for (const reg of registrations) {
    if (reg.active?.scriptURL?.includes('/OidcServiceWorker.js')) {
      await reg.unregister()
      console.log('Service worker unregistered')
    }

    // await reg.unregister()
  }
}
